import React from 'react';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import { accessors as scoreBandAccessors } from 'data/ScoreBand';
import PropTypes from 'prop-types';
import { USE_LOCAL_HFV4_SCORE_BANDS, HFV4_SCORE_BANDS } from './hfv4ScoreBands';

const ScoreBand = (props) => {
  if (is.undefined(props.band)) {
    return null;
  }
  const band = props.textKey ? props.band[props.textKey] :
    props.band.interpretation;
  return <p className={props.className} style={props.style}>{band}</p>;
};

ScoreBand.propTypes = {
  className: PropTypes.string,
  band: PropTypes.object,
  textKey: PropTypes.string,
  style: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  const { score } = ownProps;

  if (USE_LOCAL_HFV4_SCORE_BANDS) {
    const band = HFV4_SCORE_BANDS.find((b) =>
      score >= b.scorePercentageFrom && score <= b.scorePercentageTo
    );
    return { band };
  }

  const scoreBand = state.get('rootReducer').get('scoreBand');
  const language = state.get('rootReducer').get('language');
  const band = scoreBandAccessors.getBandByScore(score, language, scoreBand);
  return { band };
}

export default connect(mapStateToProps, null)(ScoreBand);



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/ScoreBand/index.jsx